import { render, staticRenderFns } from "./ReportBasicInfo.vue?vue&type=template&id=a9509d68&scoped=true&"
import script from "./ReportBasicInfo.vue?vue&type=script&lang=js&"
export * from "./ReportBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9509d68",
  null
  
)

export default component.exports